define.alias("shared/components/shared/post/secondary/caption-writer/landing-card", "settings/components/shared/post/secondary/caption-writer/landing-card");